'use strict';

const BaseSelectMenuComponent = require('./BaseSelectMenuComponent');

/**
 * Represents a mentionable select menu component
 * @extends {BaseSelectMenuComponent}
 */
class MentionableSelectMenuComponent extends BaseSelectMenuComponent {}

module.exports = MentionableSelectMenuComponent;
